import { useEffect, useState } from 'react';
import { isEmpty } from '../utils/utils';
import { useSnackbar } from 'notistack';
import { useQuery } from '@apollo/client';
import CustomError from '../components/CustomError/CustomError';

function useNRPaginatedQuery({ query, options, qlObjKey, transformData, defaultValue }) {
  const { loading, error, data, refetch, networkStatus, variables } = useQuery(query, {
    notifyOnNetworkStatusChange: true,
    errorPolicy: 'all',
    ...options,
    onCompleted: data => {
      try {
        if (options?.onCompleted) {
          options.onCompleted(data);
        }
      } finally {
        setCustomLoading(false);
      }
    },
    onError: error => {
      setCustomLoading(false);
      if (options?.onError) {
        options.onError(error);
      }
    }
  });
  const [totalCount, setTotalCount] = useState(0);
  const { enqueueSnackbar } = useSnackbar();
  const [result, setResult] = useState(defaultValue);
  const [pageInfo, setPageInfo] = useState({});
  const [customLoading, setCustomLoading] = useState(true);

  useEffect(() => {
    if (data && data[qlObjKey] && networkStatus === 7) {
      if (data[qlObjKey] && data[qlObjKey].items) {
        setResult(!!transformData ? transformData(data[qlObjKey].items) : data[qlObjKey].items);
      } else if (data[qlObjKey] && data[qlObjKey].edges) {
        setResult(!!transformData ? transformData(data[qlObjKey].edges) : data[qlObjKey].edges);
      } else {
        setResult(!!transformData ? transformData(data[qlObjKey]) : data[qlObjKey]);
      }
      if (data[qlObjKey].pageInfo) {
        setPageInfo(data[qlObjKey].pageInfo);
        if (data[qlObjKey]?.pageInfo?.totalSize != null) {
          setTotalCount(data[qlObjKey].pageInfo.totalSize);
        }
        if (data[qlObjKey]?.pageInfo?.totalCount != null) {
          setTotalCount(data[qlObjKey].pageInfo.totalCount);
        }
      }
      if (data[qlObjKey].totalCount != null) {
        setTotalCount(data[qlObjKey].totalCount);
      }
    }
  }, [data, networkStatus]);

  useEffect(() => {
    if (loading) {
      setCustomLoading(true);
      setResult(defaultValue);
    }
  }, [loading]);

  const handleFetchMore = queryParams => {
    refetch(queryParams);
  };

  useEffect(() => {
    if (error && !isEmpty(error)) {
      enqueueSnackbar(<CustomError message={error?.message} />, { variant: 'error', autoHideDuration: null });
      setCustomLoading(false);
    }
  }, [error]);

  return [result, customLoading, handleFetchMore, pageInfo, true, totalCount, variables, refetch];
}

export default useNRPaginatedQuery;
